import { useState } from "react";
import { Tooltip } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import copy from "copy-to-clipboard";
import { useTheme } from "react-jss";

function Copy({ text = '', iconColor = undefined }) {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  const handleCopy = () => {
    copy(text);
    setIsOpen(true);
    setTimeout(() => setIsOpen(false), 2000);
  };

  return (
    <Tooltip title="Copied to clipboard" open={isOpen} color={theme.brandPrimary}>
      <CopyOutlined onClick={handleCopy} style={{ cursor: "pointer", color: iconColor || theme.brandPrimary }}  />
    </Tooltip>
  );
}

export default Copy;
